<template>

    <div class="list" :class="classes">
        <slot></slot>
    </div>

</template>

<style scoped lang="scss">

    .list {
        display: grid;
        gap: 10px;
        &.list-grouped {
            grid-gap: 0;
            .list-item {
                border-top: none;
                border-radius: 0;
                &:first-child {
                    border-top: 1px solid $color-rule;
                    border-top-left-radius: 5px;
                    border-top-right-radius: 5px;
                }
                &:last-child {
                    border-bottom-left-radius: 5px;
                    border-bottom-right-radius: 5px;
                }
            }
        }
    }

</style>

<script>

export default {

    props: {
        grouped: {
            type: Boolean,
            default: false,
        },
    },

    computed: {

        classes() {
            return {
                'list-grouped': this.grouped,
            }
        },

    },

}

</script>